import { useEffect } from "react"

export const useDynamicHead = () => {
  useEffect(() => {
    const theme = process.env.REACT_APP_THEME

    if (theme) {
      const faviconPath = `./favicon-${theme}.png`
      const link = document.createElement("link")

      link.rel = "icon"
      link.href = faviconPath
      document.head.appendChild(link)
    }
  }, [])
}
